import React from 'react';
import PropTypes from 'prop-types';
import { elo as theme } from '../../themes';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PlurallAvatar = function PlurallAvatar(_ref) {
  var _ref$height = _ref.height,
    height = _ref$height === void 0 ? 24 : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 24 : _ref$width;
  return ___EmotionJSX("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 18 18"
  }, ___EmotionJSX("path", {
    fill: theme.colors.shade10,
    fillRule: "evenodd",
    d: "M0 9.038c0-1.292 1.06-2.34 2.368-2.34 1.308 0 2.368 1.048  2.368 2.34 0 2.323 1.912 4.212 4.263 4.212 2.35 0 4.263-1.889  4.263-4.212 0-1.292 1.06-2.34 2.368-2.34 1.308 0 2.369 1.048  2.369 2.34 0 4.904-4.037 8.893-9 8.893C4.037 17.93 0 13.94 0  9.038zm.693-5.042A2.347 2.347 0 0 1 0 2.34C0 1.724.252  1.122.693.685A2.403 2.403 0 0 1 2.368 0c.624 0 1.233.25  1.675.685.44.437.693 1.039.693 1.655 0 .617-.252 1.219-.693  1.656a2.405 2.405 0 0 1-1.675.685c-.624 0-1.233-.25-1.675-.685zm13.264  0a2.348 2.348 0 0 1-.693-1.656c0-.616.253-1.218.693-1.655A2.4 2.4  0 0 1 15.632 0c.624 0 1.233.25 1.674.685A2.34 2.34 0 0 1 18 2.34c0  .617-.252 1.219-.694 1.656-.44.435-1.05.685-1.674.685-.624  0-1.235-.25-1.675-.685z"
  }));
};
PlurallAvatar.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default PlurallAvatar;